module.exports = __webpack_public_path__ + "238df0d6073e4a6f459af9d5598a3414.png";